var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveDispatchSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 4.95833L11.1666 8L14.2083 11.0417L15.0833 10.1667L13.5416 8.625H17.3333V7.375H13.5416L15.0833 5.83333L14.2083 4.95833ZM8.37492 1.75H1.91659L1.91659 14.25H8.37492L8.37492 1.75ZM16.0833 0.5C16.4166 0.5 16.7083 0.624999 16.9583 0.874999C17.2083 1.125 17.3333 1.41667 17.3333 1.75V6.125H16.0833V1.75L9.62492 1.75L9.62492 14.25H16.0833V9.875H17.3333V14.25C17.3333 14.5833 17.2083 14.875 16.9583 15.125C16.7083 15.375 16.4166 15.5 16.0833 15.5L1.91659 15.5C1.58325 15.5 1.29158 15.375 1.04158 15.125C0.791584 14.875 0.666586 14.5833 0.666586 14.25V1.75C0.666586 1.41667 0.791584 1.125 1.04158 0.874999C1.29158 0.624999 1.58325 0.5 1.91659 0.5L16.0833 0.5Z",
    fill: "#3282FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDispatchSelected);
export default __webpack_public_path__ + "static/media/liveDispatch-selected.fb962b656991faad432025d290d23d93.svg";
export { ForwardRef as ReactComponent };